/* eslint-disable */
import { useState, useContext, useReducer, useEffect } from "react";
import { Context } from "../../App";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { db, storage } from '../../config/firebase'
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
  onSnapshot
} from "firebase/firestore";

import LeftBarAnimation from "../../components/animations/SideBarAnimation";

import { RxCaretSort } from "react-icons/rx";
import { RxCross2 } from "react-icons/rx";
import { FiSearch } from "react-icons/fi";
import { IoDocumentText } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

import { FaRegFileImage } from "react-icons/fa6";
import { FaFileVideo } from "react-icons/fa6";
import { FaFileAudio } from "react-icons/fa6";



const MediaUploads = ({ open, onClose, height }) => {
  const rightIn = {
    hidden: {
      x: "190px",
      opacity: 0,
    },
    visible: {
      x: "0",
      opacity: 1,
      transition: {
        duration: 0.15,
        type: "spring",
        damping: 30,
        stiffness: 500,
        // type: "linear",
      },
    },
    exit: {
      x: "190px",
      opacity: 0,
    },
  };

  const [mediaTab, setMediaTab] = useState([
    {
      name: "img",
      icon: <FaRegFileImage className="h-4 w-4" />,
      desc: "Images",
      selected: true,
    },
    {
      name: "doc",
      icon: <IoDocumentText className="h-5 w-5" />,
      desc: "Documents",
      selected: false,
    },
    {
      name: "vid",
      icon: <FaFileVideo className="h-4 w-4" />,
      desc: "Videos",
      selected: false,
    },
    {
      name: "aud",
      icon: <FaFileAudio className="h-4 w-4" />,
      desc: "Audios",
      selected: false,
    },
  ])

  const location = useLocation();
  const { showUsersContext,
    showMediaContext,
    groupIdContext,
    mediaImageListC,
    mediaDocumentListC,
    clickedImageC,
  } = useContext(Context);
  const [showUsers, setShowUsers] = showUsersContext;
  const [showMedia, setShowMedia] = showMediaContext;
  const [groupId, setGroupId] = groupIdContext;

  const [percentFilter, setpercentFilter] = useState(false);
  const [timeFilter, setTimeFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [mediaList, setMediaList] = useState([]);
  const [mediaImageList, setMediaImageList] = mediaImageListC
  const [mediaDocumentList, setmediaDocumentList] = mediaDocumentListC
  const [clickedImg, setClickedImg] = clickedImageC

  const handleImgClick = (item) => {
    setClickedImg(item)
  }

  useEffect(() => {
    setMediaList([]);
    if (groupId === "") return
    let q = query(
      collection(db, "chats"),
      where("groupId", "==", groupId),
      orderBy("createdAt", "desc"),
      where("mediaType", "in", mediaTab.filter((item) => item.selected).map((item) => item.name)),
      limit(50)
    );


    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const messages = [];
      const editedMessages = [];
      const editedMessagesIds = [];
      const uid = localStorage.getItem("uid");

      querySnapshot.docChanges().forEach((change) => {
        if (change.type === "added" || change.type === "removed") {
          // console.log(change.doc.data().createdById, uid);
          messages.push(
            {
              ...change.doc.data(),
              id: change.doc.id,
              himself: change.doc.data().createdById === uid,
            });
        }
        else if (change.type === "modified") {
          editedMessagesIds.push(change.doc.id);
          editedMessages.push(
            {
              ...change.doc.data(),
              id: change.doc.id,
              himself: change.doc.data().createdById === uid,
            });
        }
      });

      setMediaList((prev) => {
        // console.log("Single Message: ", [...messages]);
        //Remove any prev Edited Message
        let prevMessages = prev.filter((item) => !editedMessagesIds.includes(item.id));

        prevMessages = [...prevMessages, ...messages, ...editedMessages];
        prevMessages = (prevMessages.filter((item) => !item.deleted).sort(function (a, b) {
          if (a.createdAt <= b.createdAt) { return 1; }
          if (a.createdAt > b.createdAt) { return -1; }
        }))

        let imgList = [];
        let docsList = [];

        prevMessages.forEach((item) => {
          if (item.mediaType === "img")
            imgList.push(item);
          else if (item.mediaType === "doc")
            docsList.push(item);
        })
        setMediaImageList(imgList)
        setmediaDocumentList(docsList)

        return prevMessages;
      });

    }, (err) => console.error(err));
    // Clean up the listener when the component unmounts
    return () => unsubscribe();

  }, [mediaTab, groupId]);


  const handleMediaTab = (name) => {

    setMediaTab((prev) => {
      const newTabs = prev.map((item) => {
        if (item.name === name) return { ...item, selected: !item.selected }
        return item
      })
      if (newTabs.filter((item) => (item.selected)).length === 0)
        return prev.map((item) => ({ ...item, selected: true }))
      else
        return newTabs
    })
  }

  function downloadURI(uri, name) {
    // console.log(name);
    var link = document.createElement("a");
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', name);
    link.setAttribute('target', "_blank");
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }


  return (
    <>
      <LeftBarAnimation showDiv={showMedia} variants={rightIn} overlayDirection={"right"} >
        <div className={`flex w-full flex-col`}>

          <div className="w-full justify-end h-full">
            <div className="flex justify-evenly w-full h-full">
              {mediaTab?.map((item, i) => (
                <button
                  key={item.name+"tabs-wervzn"}
                  style={{ "zIndex": item.selected ? 0 : 10 }}
                  className={`flex items-center justify-center px-1 py-1 text-sm w-1/2 md:text-base uppercase rounded-t-sm items-center dark:!bg-navyDL dark:shadow-none 
                            
                                ${item.selected ? "text-gray-800 hover:text-gray-700 bg-white dark:text-white " : "text-gray-600 hover:text-gray-700 bg-gray-50"}`}
                  onClick={() => { handleMediaTab(item.name) }}>

                  <div className="inline">{item.icon}</div>

                </button>

              ))}

            </div>
          </div>

          <div style={{
            "position": "relative",
            "top": "-1px"
          }} className="flex flex-col h-[calc(100vh - 180px)] w-full border-t border-headPrimary bg-white dark:bg-navyDL">

            <div className="mb-2 gap-5 bg-white uppercase p-1 h-fit">

              <div className="mt-2 w-full flex justify-between">
                <div className="ml-1 w-[49%] flex h-[19px] items-center rounded-sm bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
                  <p className="px-1">
                    <FiSearch className="h-3 w-3 text-gray-400 dark:text-white" />
                  </p>
                  <input
                    type="text"
                    placeholder="Search..."
                    className="block h-full w-full bg-lightPrimary text-xs font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />

                  <p
                    onClick={() => (setSearch(""))}
                    className="pl-1 pb-0.5 pr-1 text-xl">
                    <RxCross2 className="cursor-pointer h-3 w-3 text-gray-400 hover:text-gray-800 dark:text-white" />
                  </p>

                </div>

                <div className={`flex items-center ${percentFilter ? "text-gray-800 dark:text-white" : "text-gray-400 hover:text-gray-700"
                  }  `}
                  onClick={() => {
                    setpercentFilter((prev) => (!prev));
                  }}>
                  <p className="relative cursor-pointer text-xs">%&nbsp;</p>
                  <RxCaretSort />
                </div>

                <div className={`flex items-center ${timeFilter ? "text-gray-800 dark:text-white" : "text-gray-400 hover:text-gray-700"
                  }  `}
                  onClick={() => {
                    setTimeFilter((prev) => (!prev));
                  }}>
                  <p className="relative cursor-pointer text-xs">Time&nbsp;</p>
                  <RxCaretSort />
                </div>
              </div>
            </div>
            <hr />

            <div className={`p-3 w-full grid grid-cols-2 gap-3`}>

              {mediaList
              .filter((item) => (item.documentName?.toLowerCase().includes(search.toLowerCase()) || item.displayName?.toLowerCase().includes(search.toLowerCase())))
              .map((item, i) => (
                item.mediaType === "img" ?
                  <div key={item.id} className="w-full h-fit rounded-md border cursor-pointer shadow-md hover:shadow-lg">
                    <img
                      onClick={(() => handleImgClick(item))}
                      className="aspect-square object-cover w-full rounded-md" src={item.url} alt="" />
                  </div>

                  : item.mediaType === "doc" ?
                    <div key={item.id} className="w-full flex">
                      <div
                        onClick={() => {
                          downloadURI(item.url, item.documentName)
                        }}
                        className="cursor-pointer group w-full aspect-square flex flex-col items-center p-1 bg-white border border-gray-400 rounded-lg">

                          <div className="text-[8px] px-0.5 w-full truncate font-normal">{item.documentName}</div>

                          <div className="relative mt-2 w-10 h-10 aspect-square">

                            <IoDocumentText className='h-full w-full group-hover:opacity-50' />

                            <div className="hidden group-hover:flex absolute top-0 bottom-0 left-0 right-0 m-auto items-center justify-center ">
                              <FiDownload className='w-10 h-10 text-headPrimary bg-lightPrimary p-1 rounded-md' />
                            </div>
                          </div>
                      </div>
                    </div>

                    :
                    <></>
              ))}

            </div>

          </div>
        </div>
      </LeftBarAnimation>
    </>
  );
};

export default MediaUploads;
